"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../../Themes/styled-components"));
var Content = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n"])));
var Top = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Bottom = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var Main = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  flex: 1 0 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  flex: 1 0 0;\n"])));
var C = function (_a) {
    var topFixed = _a.topFixed, children = _a.children, bottomFixed = _a.bottomFixed, className = _a.className;
    return (React.createElement(Content, { className: className },
        React.createElement(Top, null, topFixed),
        React.createElement(Main, null, children),
        React.createElement(Bottom, null, bottomFixed)));
};
exports.default = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
